import React from "react";
import { cn } from "../../lib/utils";
import { Avatar, AvatarImage } from "./avatar";
export interface TestimonialAuthor {
  name: string;
  handle: string;
  avatar: string;
}
export interface TestimonialCardProps {
  author: TestimonialAuthor;
  text: string;
  href?: string;
  className?: string;
}
export function TestimonialCard({
  author,
  text,
  href,
  className
}: TestimonialCardProps) {
  const Card = href ? "a" : "div";
  return <Card {...href ? {
    href,
    target: "_blank",
    rel: "noopener noreferrer"
  } : {}} className={cn("flex flex-col rounded-lg border border-white/10", "bg-neutral-900/50", "p-4 text-start sm:p-6", "hover:bg-neutral-900/70", "max-w-[320px] sm:max-w-[320px]", "transition-colors duration-300", className)} data-id="element-111">
      <div className="flex items-center gap-3" data-id="element-112">
        <Avatar className="h-12 w-12" data-id="element-113">
          <AvatarImage src={author.avatar} alt={author.name} data-id="element-114" />
        </Avatar>
        <div className="flex flex-col items-start" data-id="element-115">
          <h3 className="text-md font-semibold leading-none text-white" data-id="element-116">
            {author.name}
          </h3>
          <p className="text-sm text-white/60" data-id="element-117">{author.handle}</p>
        </div>
      </div>
      <p className="sm:text-md mt-4 text-sm text-white/80" data-id="element-118">{text}</p>
    </Card>;
}